import React from "react";
import { BellRing } from "lucide-react";
import { formatDate } from "../../lib/practiceApi";
import { sisterTone } from "./constants";
import "./catasto.css";

const ORDER = { Scaduta: 0, "Da verificare": 1, "In scadenza": 2, "In programma": 3 };

export const collectSisterChecks = practices => practices.flatMap(p => p.catasto_controlli_sister || [])
  .sort((a, b) => ORDER[a.status] - ORDER[b.status] || a.data_controllo_sister.localeCompare(b.data_controllo_sister));

export const SisterChecks = ({ checks, title = "Controlli Sister", onOpenPractice, limit, testId = "sister-checks" }) => {
  if (!checks.length) return null;
  const shown = limit ? checks.slice(0, limit) : checks;
  return <section className="sister-checks" data-testid={testId}>
    <header><h3><BellRing size={15} /> {title} <span className="muted" data-testid={`${testId}-count`}>{checks.length}</span></h3>
      {limit && checks.length > limit && <small className="muted">Altri {checks.length - limit} nella sezione scadenze</small>}</header>
    {shown.map(check => <article className="sister-check" key={check.id} data-testid={`${testId}-item-${check.record_id}`}>
      <span className={`catasto-badge ${sisterTone(check.status)}`} data-testid={`${testId}-status-${check.record_id}`}>{check.status}</span>
      <div>
        <strong data-testid={`${testId}-message-${check.record_id}`}>{check.message}</strong>
        <small>{check.label} {check.numero}{check.protocollo ? ` · prot. ${check.protocollo}` : ""} · controllo {formatDate(check.data_controllo_sister)}{check.data_scadenza ? ` · scadenza ${formatDate(check.data_scadenza)}` : ""}</small>
      </div>
      {onOpenPractice && <button type="button" className="link" data-testid={`${testId}-open-${check.record_id}`} onClick={() => onOpenPractice(check.practice_id)}>{check.practice_name || "Apri pratica"}{check.client_name ? ` · ${check.client_name}` : ""}</button>}
    </article>)}
  </section>;
};
